
import { Component, Prop, Vue } from 'vue-property-decorator';
import AuthGroup from '@/logic/auth/AuthGroup';

@Component
export default class DashboardStatusBlock extends Vue {
  @Prop(Object)
  block!: any;

  isVisibleToUser(): boolean {
    return this.$store.getters['auth/memberOf'](AuthGroup.Direct);
  }
}
